import SEO from '@/components/base/SEO';

export default function ArticlePage() {
  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <SEO title="文章详情 - 番号大全" description="番号评测、排行、科普文章" />
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-2xl">
          <i className="ri-article-line text-accent-500 text-2xl"></i>
        </div>
        <h2 className="font-heading text-xl font-semibold text-foreground-800 mb-2">文章详情</h2>
        <p className="text-sm text-foreground-500">即将上线，敬请期待</p>
      </div>
    </div>
  );
}